<template>
  <section class="d-flex gap-4 flex-column flex-wrap justify-content-center align-items-center">
    <template v-if="!lessons.length">
      <skeleton-lessons></skeleton-lessons>
    </template>
    <template v-else>
      <div
        v-for="(lesson, idx) in lessons"
        :key="idx"
        class="card-lesson w-100 atm-rounded atm-shadow"
        @click.stop="
          $router.push({
            name: 'lesson',
            params: { id: moduleId, lesson: lesson.id },
          })
        "
      >
        <div>
          <span class="font-weight-bolder mr-2">Lesson {{ idx + 1 }}:</span>
          <span>{{ lesson.name }}</span>
        </div>
        <div class="d-flex gap-4 align-items-center">
          <section class="label mx-3">
            <b-badge v-if="lesson.parent_page" class="px-2">Adult review</b-badge>
          </section>
          <span class="material-icons" :class="{ completed: lesson.viewed }">
            check_circle
          </span>
        </div>
      </div>
    </template>
  </section>
</template>

<script>
import { useLearnSkillsStore } from '@/common/plugins/store';
import SkeletonLessons from '../components/skeletons/SkeletonLessons.vue';
export default {
  components: { SkeletonLessons },
  data() {
    const store = useLearnSkillsStore();
    return {
      store,
    };
  },
  computed: {
    moduleId() {
      return this.$route.params.id;
    },
    lessons() {
      return this.store.getLessons()
    },
  },
};
</script>

<style lang="scss" scoped>
.card-lesson {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f3f3f3;
  padding: 1.2rem;
  border-radius: 12px;
  cursor: pointer;
  .material-icons {
    color: white;
    &.completed {
      color: var(--color-main) !important;
    }
  }
}
</style>
